/* floating-buttons.js
 * Lovable parity: scroll-to-top button appears after scrolling past the
 * configured threshold; smooth-scrolls back to 0 on click. WhatsApp button
 * is rendered statically via Liquid and needs no JS.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-floating-buttons]');
  if (!root) return;

  const scrollBtn = root.querySelector('[data-scroll-top]');
  if (!scrollBtn) return;

  const threshold = parseInt(root.getAttribute('data-scroll-threshold'), 10) || 400;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let raf = 0;
  function update() {
    raf = 0;
    if (window.scrollY > threshold) {
      scrollBtn.removeAttribute('hidden');
      scrollBtn.classList.add('is-visible');
    } else {
      scrollBtn.classList.remove('is-visible');
      // Wait for fade-out before re-hiding so the transition can play.
      window.setTimeout(function () {
        if (!scrollBtn.classList.contains('is-visible')) {
          scrollBtn.setAttribute('hidden', '');
        }
      }, 220);
    }
  }

  function onScroll() {
    if (raf) return;
    raf = window.requestAnimationFrame(update);
  }

  scrollBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  update(); // run once on load in case user is already scrolled
})();
